
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  auth: false,
  async fetch() {
    const res = await this.getPackages()
    console.log('pricing', res)
    this.packageItem=res.package
    // if (this.packageItem) {
    //   this.packageItem.map(
    //     el => (el.price = this.$options.filters.priceDecim(el.price))
    //   )
    // }
    // if (this.packageItem1) {
    //   this.packageItem1.map(
    //     el => (el.price = this.$options.filters.priceDecim(el.price))
    //   )
    // }
  },
  data() {
    return {
      alreadyPaidForThis:false,
      showMonthlyOrYearlyDialog:false,
      packageItem: [],

      showSchedule: false,
      addonSelected: false,
      showLoginDialogInfo:false,
      selectedPriceOption:null,
      selectedPackage:{ "id": 2, "name": "Starter", "photo": "https://royalasia.blob.core.windows.net/default/2_Starter.png", "price": "999", "description": [ "", "per agent", "billed annually", "or 1,100 month-to-month" ], "features": [ { "id": 3, "name": "100 listings/mo" }, { "id": 4, "name": "6 photos/listing" }, { "id": 5, "name": "Custom Website" }, { "id": 6, "name": "Professional Documents" }, { "id": 7, "name": "Business Cards" }, { "id": 27, "name": "AI Price Guide" }, { "id": 28, "name": "Daily Inquiries" } ], "priceOption": [ { "id": 2, "name": "Pay 999 baht/mo. for 1 year" }, { "id": 1, "name": "Pay 1,100 baht/mo. every month" } ] },
      selectedAddons:[],



      "userType": [
        { "id": 6, "name": "Agent" },
        { "id": 2, "name": "Property Manager" },
        { "id": 3, "name": "Owner/Landlord" },
        { "id": 4, "name": "Tenant" },
        { "id": 5, "name": "Vendor" }
      ],
      role:6,
      continueToRole:false,
      showImagepopup:false,
      showRegisterPopup:false
    }
  },
  watch:{
    'packageItem'(){
      console.log("this.$auth packageItem",this.$auth)
      if(this.$auth?.user&&this.$auth?.user?.package?.activePackage&&this.packageItem.length){
        this.selectedPackage=this.packageItem.filter(el=>el.id==this.$auth?.user?.package?.activePackage?.id)[0]
      }
    },
    selectedPackage(){
      if(this.$breakpoint.is.mobile && (this.$auth?.user&&this.$auth?.user?.package?.activePackage&&this.packageItem.length)){
        window.$nuxt.$vuetify.goTo('#continueButton', {
          duration: 800,
          easing: 'easeInQuint'
        })
      }
    }
  },
  created() {
    // this.initialize()

  },
  mounted() {
    this.$on('showSchedule', event => {
      console.log(event)
      this.showSchedule = false
    })

  },
  computed: {
    ...mapState('config/site', [
      'siteConfig']),
    ...mapState('taxonomy', ['taxonomy']),
    disabledMenus() {
      if (process.browser) {
        return (
          window.location.origin === 'https://Properdee.com' ||
          window.location.origin === 'https://www.Properdee.com' ||
          window.location.origin === 'https://Properdee.co.th' ||
          window.location.origin === 'https://www.Properdee.co.th'
        )
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions('config/site', ['setTypeOfLoginwant']),
    ...mapMutations('config/site', ['setLogInDialogShow', 'setScheduleShow']),
    ...mapActions('packages', ['getPackages']),
    ...mapActions('authentication', ['chosePakcage']),
    openDialog(type) {
      // this.closeDrawer()
      this.setScheduleShow({ demo: true, visit: false })
    },

    select() {
      console.log(this.packageItem)
      console.log(this.localStorage)
      localStorage.setItem('selectedPackage', JSON.stringify(this.selectedPackage));
      localStorage.setItem('selectedAddons', this.selectedAddons?this.selectedAddons:null);
      if(this.selectedPackage.currentPlan && !this.selectedAddons.length){
        this.alreadyPaidForThis=true
      }else if((this.selectedPackage.id==1&& !this.selectedAddons.length)||(this.selectedPackage.id==1 && this.selectedAddons.length)||(this.selectedPackage.currentPlan)){
        this.sendUserToPayment()
      } else{
        this.showMonthlyOrYearlyDialog=true
      }


    },
    priceOptionSelected(){
      this.showMonthlyOrYearlyDialog=false
      this.sendUserToPayment()
    },
    sendUserToPayment(){
      if (this.$auth.loggedIn && this.selectedPackage.id) {
        this.sendPackage()
        this.$router.push(this.localePath({
          path: `/payment/${this.selectedPackage.id}?addons=${this.selectedAddons}`,
        }))
      } else {
        this.continueToRole=true

      }
    },
    sendPackage(){
      const id= JSON.parse(localStorage.getItem('selectedPackage')).id
      // const addons= JSON.parse(localStorage.getItem('selectedAddons'))
      this.chosePakcage({
        "email": this.$auth.user.email,
        "packageId": id,
        "addOns": this.selectedAddons?[this.selectedAddons]:null,
        "selectedPriceOption":this.selectedPriceOption
      }).then(data=>{
        console.log("sendPackage",data)
      })
    },
    checkrole(){
      console.log("this.role", this.role)
      if(this.role!=2&&this.role!=6){
        console.log("if")
        this.showImagepopup=true
        this.continueToRole=false
      }else{
        this.showRegisterPopup=true
        this.continueToRole=false
      }
    },
    showRegister(ev){
      this.showRegisterPopup = false
    }
  },
  // destroyed() {
  //   this.setLogInDialogShow(false)
  // },
}
